import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'frontend-sag';
    protected wasScrolled = false;

    constructor(private translate: TranslateService, private router: Router) {}

    ngOnInit(): void {
        this.routeToRedirect();
        this.translate.setDefaultLang('en');
        this.translate.use('en');
    }

    private routeToRedirect(): void {
        const url = window.localStorage.getItem('redirectUrl');
        if (url) {
            void this.router.navigateByUrl(url);
            window.localStorage.removeItem('redirectUrl');
        }
    }
}
